import { render, staticRenderFns } from "./auditDetail.vue?vue&type=template&id=5fcc17f2"
import script from "./auditDetail.vue?vue&type=script&lang=js"
export * from "./auditDetail.vue?vue&type=script&lang=js"
import style0 from "./auditDetail.vue?vue&type=style&index=0&id=5fcc17f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports